/**
 * Orders by compare, reversed when descending. Blank rows go last whichever way the sort runs;
 * reversing compare alone would bring them to the top.
 */
export const sortComparator = <I>(
	compare: (a: I, b: I) => number,
	desc: boolean,
	isBlank?: (item: I) => boolean,
) => (a: I, b: I) => {
	if (isBlank) {
		const aBlank = isBlank(a);
		const bBlank = isBlank(b);
		if (aBlank !== bBlank) return aBlank ? 1 : -1;
	}
	return compare(a, b) * (desc ? -1 : 1);
};
